export default {
  namespaced: true,

  state: () => ({
    success: '',
    error: '',
  }),

  mutations: {
    SET_SUCCESS(state, payload) {
      state.success = payload
    },
    SET_ERROR(state, payload) {
      state.error = payload
    },
  },

  actions: {
  },
}
